import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import Loader from '../components/Loader';
import { FaSave } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { PiDotsThree } from 'react-icons/pi';
import { formatDateTime } from '../utils/formatDate';
import Pagination from '../components/Pagination';

const Claims = () => {
  const [claimData, setClaimData] = useState({
  });
  const [packages, setPackages] = useState([]);
  const [unprocessedPackages, setUnprocessedPackages] = useState([]);
  const  [currentPage, setCurrentPage] = useState(1);

  const [openModal, setOpenModal] = useState([]);
  const [modalData, setModalData] = useState(null); // Modal data for Add/Edit
  const [deleteId, setDeleteId] = useState(null); // ID for delete confirmation
  const [activeTab, setActiveTab] = useState('unapproved');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [metaData, setMetaData] = useState({
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
    pageSize: 10,
  });

  const apiUrl = 'process.env.REACT_APP_BASE_URL';
  const user = JSON.parse(localStorage.getItem('user'));


  const fetchPackages = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(user.role == "Courier" ? `${apiUrl}/api/claims/${user.courier_id}?page=${currentPage}` : `${apiUrl}/api/claims`);
      if (!response.ok) throw new Error('Failed to fetch packages');
      const data = await response.json();
      setUnprocessedPackages(data.packages.filter((pkg) => !pkg.approved));
      setPackages(data.packages.filter((pkg) => pkg.approved));
      setMetaData(data.meta || {});
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchPackages();
  // }, [currentPage]);

  const handleTabChange = (tab) => setActiveTab(tab);

  const handleSave = async (data) => {
    try {
      const method = data.id ? 'PUT' : 'POST';
      const url = data.id
        ? `${apiUrl}/api/packages/${data.id}`
        : `${apiUrl}/api/unknown-packages`;

      const response = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });
      if (!response.ok) throw new Error('Error saving package');
      await fetchPackages();
      setModalData(null);
    } catch (err) {
      setError('Error saving package. Please try again.');
    }
  };
  const handleApproval = async (id) =>{
    const toApprove = [...packages, ...unprocessedPackages].find((approve) => approve.id === id)
    if (toApprove) {
      const response = await fetch(`${apiUrl}/api/packages/approve/${toApprove.tracking_number}`, {
        method: 'PUT', 
        body: JSON.stringify({
        trackingNumber: toApprove.tracking_number,
        staff_id: user.id,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    }
    fetchPackages();
  }

  const handleDelete = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/unknown-packages/${deleteId}`, {
        method: 'DELETE',
      });
      if (!response.ok) throw new Error('Error deleting package');
      await fetchPackages();
      setDeleteId(null);
    } catch (err) {
      setError('Error deleting package. Please try again.');
    }
  };

  const sampleData = [
    {
      "package": "Electronics",
      "tracking_number": "TRK123456",
      "account": {
        "first_name": "John",
        "last_name": "Doe"
      },
      "shipper_username": "FastExpress",
      "approved": "2025-02-01T12:30:00Z"
    },
    {
      "package": "Clothing",
      "tracking_number": "TRK654321",
      "account": null,
      "shipper_username": "QuickShip",
      "approved": "--"
    },
    {
      "package": "Books",
      "tracking_number": "TRK789012",
      "account": {
        "first_name": "Jane",
        "last_name": "Smith"
      },
      "shipper_username": "SpeedyLogistics",
      "approved": "2025-01-29T15:20:00Z"
    },
    {
      "package": "Furniture",
      "tracking_number": "TRK345678",
      "account": {
        "first_name": "Michael",
        "last_name": "Brown"
      },
      "shipper_username": "",
      "approved": "--"
    },
    {
      "package": "Kitchenware",
      "tracking_number": "TRK901234",
      "account": {
        "first_name": "Emily",
        "last_name": "Davis"
      },
      "shipper_username": "ExpressTrack",
      "approved": "2025-01-27T08:45:00Z"
    },
    {
      "package": "Automotive Parts",
      "tracking_number": "TRK567890",
      "account": null,
      "shipper_username": "SwiftDeliveries",
      "approved": "--"
    },
    {
      "package": "Medical Supplies",
      "tracking_number": "TRK112233",
      "account": {
        "first_name": "David",
        "last_name": "Wilson"
      },
      "shipper_username": "ParcelPro",
      "approved": "2025-01-25T14:10:00Z"
    },
    {
      "package": "Sports Equipment",
      "tracking_number": "TRK445566",
      "account": {
        "first_name": "Sophia",
        "last_name": "Martinez"
      },
      "shipper_username": "",
      "approved": "--"
    },
    {
      "package": "Home Appliances",
      "tracking_number": "TRK778899",
      "account": {
        "first_name": "Daniel",
        "last_name": "Taylor"
      },
      "shipper_username": "ReliableCouriers",
      "approved": "2025-01-23T09:30:00Z"
    },
    {
      "package": "Toys",
      "tracking_number": "TRK990011",
      "account": null,
      "shipper_username": "GlobalFreight",
      "approved": "--"
    }
  ]
  const unsampleData = [
    {
      "package": "Laptops",
      "tracking_number": "TRK223344",
      "account": {
        "first_name": "Liam",
        "last_name": "Johnson"
      },
      "shipper_username": "FastTrack",
      "approved": false
    },
    {
      "package": "Shoes",
      "tracking_number": "TRK556677",
      "account": null,
      "shipper_username": "QuickShip",
      "approved": false
    },
    {
      "package": "Smartphones",
      "tracking_number": "TRK889900",
      "account": {
        "first_name": "Olivia",
        "last_name": "Garcia"
      },
      "shipper_username": "ExpressGo",
      "approved": false
    },
    {
      "package": "Gaming Consoles",
      "tracking_number": "TRK112244",
      "account": {
        "first_name": "Ethan",
        "last_name": "Martinez"
      },
      "shipper_username": "",
      "approved": false
    },
    {
      "package": "Jewelry",
      "tracking_number": "TRK334466",
      "account": {
        "first_name": "Ava",
        "last_name": "Lopez"
      },
      "shipper_username": "LuxuryShip",
      "approved": false
    },
    {
      "package": "Watches",
      "tracking_number": "TRK778899",
      "account": null,
      "shipper_username": "TimeTrack",
      "approved": false
    },
    {
      "package": "Handbags",
      "tracking_number": "TRK990011",
      "account": {
        "first_name": "Mason",
        "last_name": "Hernandez"
      },
      "shipper_username": "ParcelXpress",
      "approved": false
    },
    {
      "package": "Perfumes",
      "tracking_number": "TRK223311",
      "account": {
        "first_name": "Charlotte",
        "last_name": "Gonzalez"
      },
      "shipper_username": "",
      "approved": false
    },
    {
      "package": "Tablets",
      "tracking_number": "TRK556633",
      "account": {
        "first_name": "James",
        "last_name": "Walker"
      },
      "shipper_username": "SwiftLogistics",
      "approved": false
    },
    {
      "package": "Cameras",
      "tracking_number": "TRK889922",
      "account": null,
      "shipper_username": "PhotoFreight",
      "approved": false
    }
  ]
  
  

  const PackageTable = ({ packages, onApprove, onDelete }) => (
    <table className="table-auto w-full border-collapse border border-gray-300">
      <thead className="bg-gray-100">
        <tr>
          <th className="border px-2 sm:px-4 py-2">Package</th>
          <th className="border px-2 sm:px-4 py-2">Tracking Number</th>
          <th className="border px-2 sm:px-4 py-2">Account</th>
          <th className="border px-2 sm:px-4 py-2">Courier</th>
          <th className="border px-2 sm:px-4 py-2">Approved</th>
          <th className="border px-2 sm:px-4 py-2">Actions</th>
        </tr>
      </thead>
      <tbody>
        {packages.length > 0 ? (
          packages.map((pkg) => (
            <tr key={pkg.id} className="hover:bg-slate-200">
              <td className="border px-2">{pkg.package}</td>
              <td className="border px-2">{pkg.tracking_number}</td>
              <td className="border px-2">{pkg?.account != null  ? `${pkg?.account?.first_name} ${pkg?.account?.first_name}` : '----'}</td>
              <td className="border px-2">{pkg?.shipper?.username ?? ''}</td>
              <td className="border px-2">
                {pkg.approved ? pkg.updated_at : '--'}
              </td>
              {user.role == "Courier" ? "" : <td className="border px-2 flex gap-2">
                <button className="btn btn-sm btn-secondary" onClick={() => onApprove(pkg.id)}>
                  {pkg.approved ? 'Unapprove' : 'Approve'}
                </button>
                {/* <button className="btn btn-sm btn-danger" onClick={() => setDeleteId(pkg.id)}>
                  Delete
                </button> */}
              </td>}
              
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="6" className="text-center">
              No Packages Available
            </td>
          </tr>
        )}
      </tbody>
 
    </table>
  );

  return (
    <Layout>
      {loading ? (
        <Loader />
      ) : (
        <div className="card lg:h-full w-4/5 lg:w-full  p-6 bg-base-100 shadow-xl">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-3xl font-semibold">Claims</h2>
  
          </div>

          {error && <div className="alert alert-error">{error}</div>}

          <div className="tabs">
            <button
              className={`tab ${activeTab === 'unapproved' ? 'tab-active bg-primary' : ''}`}
              onClick={() => handleTabChange('unapproved')}
            >
              Unapproved
            </button>
            {user.role !== "Courier" ? <button
              className={`tab ${activeTab === 'approved' ? 'tab-active bg-primary' : ''}`}
              onClick={() => handleTabChange('approved')}
            >
              Approved
            </button> : null}
            
          </div>

          {activeTab === 'unapproved' && (
            <PackageTable
              packages={unsampleData}
              onApprove={(id) => handleApproval(id)}
              onDelete={(id) => setDeleteId(id)}
            />
          )}
          {activeTab === 'approved' && user.role !== "Courier" && (
            <PackageTable
              packages={sampleData}
              onApprove={(id) => handleApproval(id)}
              onDelete={(id) => setDeleteId(id)}
            />
          )}
               <Pagination
          currentPage={metaData.currentPage}
          totalPages={metaData.totalPages}
          onPageChange={(page) => setCurrentPage(page)}
        />
        </div>
        
      )}

      {/* Add/Edit Modal */}
    

      {/* Delete Confirmation Modal */}
      {/* {deleteId && (
        <dialog className="modal modal-open">
          <div className="modal-box">
            <h3>Confirm Deletion</h3>
            <p>Are you sure you want to delete this package?</p>
            <div className="modal-action">
              <button className="btn" onClick={() => setDeleteId(null)}>
                Cancel
              </button>
              <button className="btn btn-danger" onClick={handleDelete}>
                Delete
              </button>
            </div>
          </div>
        </dialog>
      )} */}
    </Layout>
  );
};

export default Claims;


// {openModal && (
//   <dialog className="modal modal-open bg-gray-50">
//     <form
//       className="modal-box"
//       onSubmit={(e) => {
//         e.preventDefault();
//         handleSave(modalData);
//       }}
//     >
//       <h3 className="font-bold text-lg">{modalData.id ? 'Edit Package' : 'Add Package'}</h3>
//       <div className="form-control">
//         <label htmlFor="tracking_number">Tracking Number</label>
//         <input
//           type="text"
//           name="tracking_number"
//           value={modalData.tracking_number || ''}
//           onChange={(e) =>
//             setModalData((prev) => ({ ...prev, tracking_number: e.target.value }))
//           }
//           className="input input-bordered"
//           required
//         />
//       </div>
//       {/* Add other fields here */}
//       <div className="modal-action">
//         <button type="button" className="btn" onClick={() => setModalData(null)}>
//           Cancel
//         </button>
//         <button type="submit" className="btn btn-primary">
//           <FaSave />
//           Save
//         </button>
//       </div>
//     </form>
//   </dialog>
// )}